import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/no-data.png'


const _hoisted_1 = { class: "users--container ma--top-1" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row ma--bottom-1"
}
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "btn--group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user-plus btn--icon__prefix" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Add User", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-id-card-alt btn--icon__prefix" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Assign User", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-id-card-alt btn--icon__prefix" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Invite User", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "card-content" }
const _hoisted_20 = { class: "table table--striped" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Email", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Firstname", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Lastname", -1)
const _hoisted_24 = {
  key: 0,
  class: "text--align-left"
}
const _hoisted_25 = {
  key: 1,
  class: "text--align-left"
}
const _hoisted_26 = {
  key: 2,
  class: "text--align-right"
}
const _hoisted_27 = { class: "text--align-left" }
const _hoisted_28 = { class: "text--align-left" }
const _hoisted_29 = { class: "text--align-left" }
const _hoisted_30 = {
  key: 0,
  class: "text--align-left"
}
const _hoisted_31 = ["data-tooltip"]
const _hoisted_32 = {
  key: 2,
  class: "text--align-right"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["data-tooltip", "onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-key" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["onClick", "disabled"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = ["onClick", "disabled"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { colspan: "7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_49 = [
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateUser = _resolveComponent("CreateUser")!
  const _component_AssignUser = _resolveComponent("AssignUser")!
  const _component_UpdateSubscription = _resolveComponent("UpdateSubscription")!
  const _component_ChangePassword = _resolveComponent("ChangePassword")!
  const _component_InviteUser = _resolveComponent("InviteUser")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn--primary bottom right",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createUser('Add User'))),
                        "data-tooltip": "Create a new user account."
                      }, _hoisted_12))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn--purple ma--x-1 bottom right",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleAssignUserModel = true)),
                        "data-tooltip": "Assign existing user to current site."
                      }, _hoisted_15))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn--green bottom right",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleInviteUserModel = true)),
                        "data-tooltip": "Invite new user to current site."
                      }, _hoisted_18))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("table", _hoisted_20, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      (_ctx.isAdmin || _ctx.isSuperAdmin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_24, " Role "))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin || _ctx.isSuperAdmin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_25, " Status "))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin || _ctx.isSuperAdmin)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_26, " Action "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_27, _toDisplayString(item.email), 1),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(item.firstName), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(item.lastName), 1),
                        (_ctx.isAdmin || _ctx.isSuperAdmin)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(item.role), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin || _ctx.isSuperAdmin)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 1,
                              class: _normalizeClass(["text--align-left legend__item", {
                      'before--color-blue': item.enabled,
                      'before--color-red': !item.enabled,
                    }])
                            }, [
                              _createElementVNode("div", {
                                "data-tooltip": 
                        item.enabled
                          ? 'User is actively registered and logged in portal.'
                          : 'User has not accepted the invite yet.'
                      
                              }, _toDisplayString(item.enabled ? "ACTIVE" : "PENDING"), 9, _hoisted_31)
                            ], 2))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin || _ctx.isSuperAdmin)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                              (
                        (item.role == 'CLIENT' || item.role == 'ADMIN') &&
                        item.id != _ctx.currentUserId
                      )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (item.enabled && _ctx.isSuperAdmin)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "btn--inline btn--green btn--currency",
                                          onClick: ($event: any) => (_ctx.updateSubscription(item)),
                                          "data-tooltip": "Update Subscription",
                                          disabled: true
                                        }, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(["fa", {
                          'fa-ban': (item.additionalInfo ==null),
                          'fa-strikethrough': (item.additionalInfo !=null),
                        }])
                                          }, null, 2)
                                        ], 8, _hoisted_33))
                                      : _createCommentVNode("", true),
                                    (!item.enabled && _ctx.isSuperAdmin)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "btn--inline btn--green",
                                          onClick: ($event: any) => (_ctx.approveUser(item)),
                                          "data-tooltip": "Approve User"
                                        }, _hoisted_36, 8, _hoisted_34))
                                      : _createCommentVNode("", true),
                                    (item.enabled)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 2,
                                          class: "btn--inline btn--lock",
                                          "data-tooltip": 
                          item.locked
                            ? 'Unlock user access'
                            : 'Lock user access'
                        ,
                                          onClick: ($event: any) => (_ctx.restrictUser(item))
                                        }, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(["fa", {
                            'fa-lock-open': item.locked,
                            'fa-lock': !item.locked,
                          }])
                                          }, null, 2)
                                        ], 8, _hoisted_37))
                                      : _createCommentVNode("", true),
                                    (_ctx.isSuperAdmin)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 3,
                                          class: "btn--inline btn--secondary ma--right-1",
                                          onClick: ($event: any) => (_ctx.changePassword(item)),
                                          "data-tooltip": "Change Password"
                                        }, _hoisted_40, 8, _hoisted_38))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      class: "btn--inline btn--primary",
                                      onClick: ($event: any) => (_ctx.createUser('Update User', item)),
                                      "data-tooltip": "Edit Profile",
                                      disabled: !item.enabled && !_ctx.isSuperAdmin
                                    }, _hoisted_43, 8, _hoisted_41),
                                    _createElementVNode("button", {
                                      class: "btn--inline btn--delete",
                                      onClick: ($event: any) => (_ctx.deleteUser(item)),
                                      "data-tooltip": "Permanently delete the user.",
                                      disabled: !item.enabled && !_ctx.isSuperAdmin
                                    }, _hoisted_46, 8, _hoisted_44)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_ctx.response.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_47, _hoisted_49))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.toggleCreateModel)
                  ? (_openBlock(), _createBlock(_component_CreateUser, {
                      key: 0,
                      accessType: _ctx.accessType,
                      data: _ctx.request,
                      onCloseModel: _ctx.onCloseCreateUserModel
                    }, null, 8, ["accessType", "data", "onCloseModel"]))
                  : _createCommentVNode("", true),
                (_ctx.toggleAssignUserModel)
                  ? (_openBlock(), _createBlock(_component_AssignUser, {
                      key: 1,
                      onClose: _ctx.onCloseAssignModel,
                      onAssigned: _ctx.assignedEmail,
                      onUnassigned: _ctx.unAssignedUser
                    }, null, 8, ["onClose", "onAssigned", "onUnassigned"]))
                  : _createCommentVNode("", true),
                (_ctx.toggleUpdateSubscriptionModel)
                  ? (_openBlock(), _createBlock(_component_UpdateSubscription, {
                      key: 2,
                      user: _ctx.selectedUser,
                      onClose: _ctx.onCloseUpdateSubscription,
                      onUpdated: _ctx.updatedSubscription
                    }, null, 8, ["user", "onClose", "onUpdated"]))
                  : _createCommentVNode("", true),
                (_ctx.toggleChangePasswordModel)
                  ? (_openBlock(), _createBlock(_component_ChangePassword, {
                      key: 3,
                      user: _ctx.selectedUser,
                      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleChangePasswordModel = false))
                    }, null, 8, ["user"]))
                  : _createCommentVNode("", true),
                (_ctx.toggleInviteUserModel)
                  ? (_openBlock(), _createBlock(_component_InviteUser, {
                      key: 4,
                      onClose: _ctx.onCloseInviteModel,
                      onAssigned: _ctx.invitedEmail
                    }, null, 8, ["onClose", "onAssigned"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
  ]))
}